// @ts-nocheck
/* eslint-disable react/prop-types */
import React from 'react';
import { Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ReactComponent as CheckIcon } from '../assets/CheckIcon.svg';
import { ReactComponent as IndeterminateIcon } from '../assets/IndeterminateIcon.svg';

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: 0,
  width: 20,
  height: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '& .MuiSvgIcon-root': {
    fontSize: 0,
  },

  '&.MuiCheckbox-root': {
    borderRadius: 6,
  },

  '& .MuiTouchRipple-root': {
    display: 'none',
  },

  '& .checkbox-box': {
    width: 20,
    height: 20,
    borderRadius: 6,
    border: `1px solid ${theme.palette.text?.disabled}`,
    backgroundColor: theme.palette.background?.default,
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& svg': {
      width: 14,
      height: 14,
      color: theme.palette.background?.default,
      display: 'block',
    },
  },

  '&.Mui-checked .checkbox-box': {
    backgroundColor: theme.palette.primary?.main,
    border: `1px solid ${theme.palette.background?.default}`,
  },

  '&.MuiCheckbox-indeterminate .checkbox-box': {
    backgroundColor: theme.palette.primary?.main,
    border: `1px solid ${theme.palette.background?.default}`,
  },
}));

const SolyticsCheckbox = ({
  id,
  name,
  checked = false,
  indeterminate = false,
  disabled = false,
  onChange,
}) => {
  if (!name) return null;
  return (
    <StyledCheckbox
      {...(id && { id })}
      {...(name && { name })}
      disableRipple
      checked={checked}
      disabled={disabled}
      indeterminate={indeterminate}
      onChange={onChange}
      icon={<span className="checkbox-box" />}
      checkedIcon={
        <span className="checkbox-box">
          <CheckIcon />
        </span>
      }
      indeterminateIcon={
        <span className="checkbox-box">
          <IndeterminateIcon />
        </span>
      }
    />
  );
};

export default SolyticsCheckbox;
